export const lg_recording_credits = {
  lg_recording_credits_th: {
    title: "เครดิตการบันทึกประชุม",
    title1:"การใช้งานการบันทึกประชุมประจำเดือนของคุณ",
    monthly:"รายเดือน",
    month:"เดือน",
    monthly_usage_summary: "สรุปการใช้งานประจำเดือน",
    recording_logs:"รายการการบันทึกประชุม",
    search_conditions: "เงื่อนไขในการค้นหา",
    search_user: "ผู้สร้าง",
    search_topic: "ชื่อการประชุม",
    search_date: "วันที่",
    used:"ใช้ไปแล้ว",
    remaining:"คงเหลือ",
    total_quota:"โควต้าทั้งหมด",
    reset_date:"วันรีเซ็ต",
    minutes:"นาที",
    download:"ดาวน์โหลด",
    download_fail:"ดาวน์โหลดไม่สำเร็จ",
    low_credit_warning:"เครดิตใกล้หมด",
    low_credit_warning_details:"ใกล้หมดโควต้าการบันทึก (เหลือ 5 นาที) ระบบจะคิดค่าบริการเพิ่มเติมสำหรับการใช้งานที่เกินจากโควต้า",
    unavailable:"ไม่พบไฟล์บันทึก",
    saved_successfully:"บันทึกเรียบร้อยแล้ว",
    failed:"ล้มเหลว",
    headers: [
      // { text: "ลำดับ", value: "index" },
      { text: "วัน / เวลา (UTC/GMT+7)", value: "started_time" },
      { text: "หัวข้อการประชุม", value: "meeting.title" },
      { text: "ระยะเวลา (นาที)", value: "recording_duration", sortable: false },
      { text: "ลิงก์", value: "action" },
       { text: "สถานะการบันทึก", value: "status" },
    ],
  },
  lg_recording_credits_en: {
    title: "Recording Credits",
    title1:"Track your monthly recording usage",
    monthly:"Monthly",
    month:"Month",
    monthly_usage_summary: "Monthly Usage Summary",
    recording_logs:"Recording Logs",
    search_conditions: "Search Conditions",
    search_user: "User",
    search_topic: "Meeting Name",
    search_date: "Date",
    used:"Used",
    remaining:"Remaining",
    total_quota:"Total Quota",
    reset_date:"Reset Date",
    minutes:"minutes",
    download:"Download",
    download_fail:"Download Failed",
    low_credit_warning:"Low Credit Warning",
    low_credit_warning_details:"You’re almost out of recording time (5 minutes remaining). Extra charges will apply if you exceed your monthly quota.",
    unavailable:"Unavailable",
    saved_successfully:"Saved Successfully",
    failed:"Failed",
    headers: [
      // { text: "No.", value: "index" },
      { text: "Date / Time (UTC/GMT+7)", value: "started_time" },
      { text: "Meeting Title", value: "meeting.title" },
      { text: "Duration (min)", value: "recording_duration", sortable: false },
      { text: "Link", value: "action" },
       { text: "Recording Status", value: "status" },
    ],
  },
};
